<template>
  <div>
    <q-list v-if="showAutoCompleteResult" bordered separator>
      <q-item
        v-for="(item, index) in autoCompleteList"
        :key="index"
        clickable
        v-ripple
        @click="onChooseKeyword(item)"
      >
        <q-item-section>{{ item }}</q-item-section>
      </q-item>
    </q-list>
    <!-- <q-list v-if="showSearchResult" bordered separator>
            <q-item
                v-for="(item, index) in searchList"
                :key="index"
                clickable
                v-ripple
            >
                <q-item-section>{{ getProductDetail(item.cprcode) }}</q-item-section>
            </q-item>
        </q-list> -->
    <div class="row" style="padding: 0px 0px 0px 0px">
      <div
        class="row full-width"
        v-if="productCardComponent === 'ProductCardH'"
      >
        <ProductCardH
          :style="`padding: 4px; border:`"
          class="product-card-h col-xs-12 col-sm-6 col-md-4"
          v-for="(item, index) in searchListWithDetail"
          :key="(item.cprcode << 16) + index"
          :info="item"
          :maxRetry="10"
          @add-to-cart="AddToCart(item)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Search",
  components: {
    ProductCardH: () => import("@/ui/components/ProductCardH.vue"),
  },
  computed: {
    ...mapState({
      autoCompleteList: (state) => state.search.autoCompleteList,
      showAutoCompleteResult: (state) => state.search.showAutoCompleteResult,
      searchList: (state) => state.search.searchList,
      showSearchResult: (state) => state.search.showSearchResult,
    }),
    productCardComponent() {
      switch (this.displaySize) {
        case "large":
          return "ProductCardHLarge";
        default:
          return "ProductCardH";
      }
    },
    searchListWithDetail() {
      const list = [];
      this.searchList.forEach((search) => {
        if (this.$services.catalog.productMap) {
          const product = this.$services.catalog.productMap.get(search.cprcode);
          //   console.log("getProductDetail: ", product);
          if (product && product.availableStore.get(1000)) {
            list.push(product);
          }
        }
      });
      return list;
    },
  },
  methods: {
    onChooseKeyword(keyword) {
      this.$store.commit("search/setKeyword", keyword);
      this.$store.dispatch("search/search", keyword);
      this.$store.commit("search/setShowAutoCompleteResult", false);
      this.$store.commit("search/setShowSearchResult", true);
    },
  },
};
</script>

<style scoped>
.product-card-h {
  position: relative;
}
</style>
